import axios from "axios";
import { resolveBackendUrl } from "@/shared/utils/api.util";

export type OrganizationByTokenResponse = {
  name: string | null
  logo_url: string | null
};

// Endpoint public (non authentifié) côté yeati-api : on bypass le
// `fetcher` car son baseURL est scopé à `/api/benef/...` alors que
// cette route vit à la racine `/api/organizations/by_token/:token`.
export const getOrganizationByToken = async (
  token: string,
): Promise<OrganizationByTokenResponse> => {
  const url = resolveBackendUrl(`/api/organizations/by_token/${encodeURIComponent(token)}`);
  const response = await axios.get<OrganizationByTokenResponse>(url);
  return response.data;
};
